import { z } from 'zod'

import { VISIBILITY } from '@hashnode/database-schema'
import { ParsedPageContentConfig } from './page-content'

export const pageSidebarSchema = z.object({
	type: z.literal('page'),
	path: z.string(),
})

export type ParsedPageConfig = z.infer<typeof pageSidebarSchema> & {
	pages?: ParsedPageConfig[]
}

// Page Schema
const pageSchema = pageSidebarSchema.extend({
	pages: z.optional(z.lazy(() => pageSchema.array())),
})

// Section Schema
export const sectionSchema = z.object({
	type: z.literal('section'),
	label: z.string(),
	slug: z.optional(z.string()),
	pages: z.optional(pageSchema.array()),
	visibility: z.optional(z.enum(VISIBILITY)),
})

// Updated Section Schema with Page Content

// Link Schema
export const linkSchema = z.object({
	type: z.literal('link'),
	label: z.string(),
	url: z.string(),
	visibility: z.optional(z.enum(VISIBILITY)),
})

// Sidebar Schema
export const sidebarSchema = z.array(
	z.discriminatedUnion('type', [pageSchema, sectionSchema, linkSchema]),
)

export type ParsedPageWithContent = Omit<ParsedPageConfig, 'pages'> &
	ParsedPageContentConfig & {
		pages?: ParsedPageWithContent[]
		fullSlug: string
		filePath: string
	}

// Base Schemas
export type ParsedSectionConfig = z.infer<typeof sectionSchema>
export type ParsedLinkConfig = z.infer<typeof linkSchema>
export type ParsedSidebarConfig = z.infer<typeof sidebarSchema>

export type ParsedSidebarItemConfig = ParsedPageConfig | ParsedSectionConfig | ParsedLinkConfig

export type ParsedSectionWithPageContentConfig = Omit<ParsedSectionConfig, 'pages'> & {
	pages?: ParsedPageWithContent[]
}

export type ParsedSidebarItemConfigWithPageContent =
	| ParsedPageWithContent
	| ParsedSectionWithPageContentConfig
	| ParsedLinkConfig
